/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserEntity } from './UserEntity';
import {
    UserEntityFromJSON,
    UserEntityFromJSONTyped,
    UserEntityToJSON,
    UserEntityToJSONTyped,
} from './UserEntity';

/**
 * 
 * @export
 * @interface GroupEntity
 */
export interface GroupEntity {
    /**
     * グループID
     * @type {string}
     * @memberof GroupEntity
     */
    id: string;
    /**
     * テナントID
     * @type {string}
     * @memberof GroupEntity
     */
    tenantId: string;
    /**
     * グループ名
     * @type {string}
     * @memberof GroupEntity
     */
    name: string;
    /**
     * 親グループID
     * 親グループに null を指定した場合は、トップレベルグループとなる
     * @type {string}
     * @memberof GroupEntity
     */
    parentId: string;
    /**
     * 作成日時
     * @type {Date}
     * @memberof GroupEntity
     */
    createdAt: Date;
    /**
     * 最終更新日時
     * @type {Date}
     * @memberof GroupEntity
     */
    updatedAt: Date;
    /**
     * 作成ユーザー
     * @type {UserEntity}
     * @memberof GroupEntity
     */
    createdBy: UserEntity;
    /**
     * 最終更新ユーザー
     * @type {UserEntity}
     * @memberof GroupEntity
     */
    updatedBy: UserEntity;
}

/**
 * Check if a given object implements the GroupEntity interface.
 */
export function instanceOfGroupEntity(value: object): value is GroupEntity {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('parentId' in value) || value['parentId'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('updatedBy' in value) || value['updatedBy'] === undefined) return false;
    return true;
}

export function GroupEntityFromJSON(json: any): GroupEntity {
    return GroupEntityFromJSONTyped(json, false);
}

export function GroupEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): GroupEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'tenantId': json['tenantId'],
        'name': json['name'],
        'parentId': json['parentId'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'createdBy': UserEntityFromJSON(json['createdBy']),
        'updatedBy': UserEntityFromJSON(json['updatedBy']),
    };
}

export function GroupEntityToJSON(json: any): GroupEntity {
    return GroupEntityToJSONTyped(json, false);
}

export function GroupEntityToJSONTyped(value?: GroupEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tenantId': value['tenantId'],
        'name': value['name'],
        'parentId': value['parentId'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'createdBy': UserEntityToJSON(value['createdBy']),
        'updatedBy': UserEntityToJSON(value['updatedBy']),
    };
}

